import axios from 'axios';

const profilePageData = {
	state: () => ({
		profilePageData: {},
		apiProfileUrl: '/api/myhcpprofile',
		profileData: {},
		notificationsData: {},
		consentPageUrl: '',
		consentIsAvailable: false,
		marketingPermissions: [],
		consentLoadValue: false,
		accountAccess: {},
		formMarketingPermissionModel: [],
	}),
	getters: {
		getProfilePageData: (state) => {
			return state.profilePageData;
		},
		getApiProfileUrl: (state) => {
			return state.apiProfileUrl;
		},
		getProfileData: (state) => {
			return state.profileData;
		},
		getNotificationsData: (state) => {
			return state.notificationsData;
		},
		getConsentPageUrl: (state) => {
			return state.consentPageUrl;
		},
		getConsentIsAvailable: (state) => {
			return state.consentIsAvailable;
		},
		getMarketingPermissions: (state) => {
			return state.marketingPermissions;
		},
		getConsentLoadValue: (state) => {
			return state.consentLoadValue;
		},
		getAccountAccess: (state) => {
			return state.accountAccess;
		},
		getFormMarketingPermissionModel: (state) => {
			return state.formMarketingPermissionModel;
		},
	},
	mutations: {
		setProfilePageData: (state, data) => {
			state.profilePageData = data;
		},
		setProfileData: (state, data) => {
			state.profileData = Object.assign({}, state.profileData, data);
		},
		setNotificationsData: (state, data) => {
			if ( data.marketingPermissions == null ) {
				data.marketingPermissions = { "email": false, "phone": false, "sms": false, "letter": false }
			}
			state.notificationsData = Object.assign({}, state.notificationsData, data);
		},
		setConsentPageUrl: (state, url) => {
			state.consentPageUrl = url;
		},
		setConsentIsAvailable: (state, isAvailable) => {
			state.consentIsAvailable = isAvailable;
		},
		setMarketingPermissions: (state, marketingPermissions) => {
			if ( marketingPermissions ) {
				let enabledPermissions = Object.keys(marketingPermissions).filter(key => marketingPermissions[key] === true);
				let enabledMarketingPermissions = enabledPermissions.filter(value => value !== 'informationalEmail');
				let formattedItem = enabledMarketingPermissions.findIndex(item => item === 'promotionalEmail');
				if (formattedItem !== -1) {
					enabledMarketingPermissions.splice(formattedItem, 1,'email');
				}
				state.marketingPermissions = enabledMarketingPermissions;
			} else {
				state.marketingPermissions = { "email": false, "phone": false, "sms": false, "letter": false }
			}
		},
		setUpdatedMarketingPermissions: (state, updatedMarketingPermissions) => {
			state.marketingPermissions = updatedMarketingPermissions;
		},
		setFormMarketingPermissionModel: (state, model) => {
			state.formMarketingPermissionModel = model;
		},
		setConsentLoadValue: (state, value) => {
			state.consentLoadValue = value;
		},
		setAccountAccess: (state, object) => {
			state.accountAccess = object;
		},
	},
	actions: {
		getNotificationsInfo: ({ commit }, url) => {
			axios.get(url).then(response => {
				if (response.data) {
					commit('setNotificationsData', response.data);
					commit('setMarketingPermissions', response.data.marketingPermissions);
					commit('setConsentIsAvailable', true);
				}
				commit('setConsentLoadValue', true);
			})
				.catch(error => {
					console.warn(error);
					commit('setConsentLoadValue', true);
				})
				.finally(() => {
					commit('setSpinnerIsShown', false, { root: true });
				});
		},
		getProfileDataInfo: ({ commit, rootState }, url) => {
			axios.get(url).then(response => {
				if (response?.data?.localProfile) {
					let dataToassign = response.data.localProfile;
					dataToassign.email = response.data.email;
					if (!dataToassign.culture) {
						dataToassign.culture = rootState.locale.culture;
					}
					commit('setProfileData', response.data.localProfile);
				}
			})
				.catch(error => {
					console.warn(error)
					commit('setSpinnerIsShown', false, { root: true });
				});
		}
	},
};

export default profilePageData;
